import(/* webpackMode: "eager" */ "/vercel/path0/components/50-50.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/animated-card-list.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/blog-posts.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/cal.com.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/card-grid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/cards-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/contact-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/cta-banner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/cta.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/featured-projects.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/marquee-showcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/work-status.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/@sanity+next-loader@1.7.5_@sanity+types@3.99.0_@types+react@19.2.13__next@15.2.8_@babel+core@_db2ysw6ieq3uinl4sstgb4jnr4/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/@sanity+next-loader@1.7.5_@sanity+types@3.99.0_@types+react@19.2.13__next@15.2.8_@babel+core@_db2ysw6ieq3uinl4sstgb4jnr4/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-sanity@9.12.3_@emotion+is-prop-valid@1.4.0_@sanity+client@7.14.1_@sanity+icons@3.7.4_rea_ybrirn5qhihywtzgy3kpc35bc4/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
